import { FC } from 'react'

import { match } from 'ts-pattern'

import { IntegrationServices } from '@sequencehq/api/commonEnums'
import {
  Center,
  Flex,
  GreyGrey20,
  GreyWhite,
  Tooltip
} from '@sequencehq/core-components'

import { getLogo } from 'lib/integrations/logos'

type TableLinksLogosProps = {
  services: IntegrationServices[]
}

export const TableLinksLogos: FC<TableLinksLogosProps> = ({ services }) => {
  if (!services.length) return null

  return (
    <Flex gap="4px" overflow="hidden">
      {services.map(service => {
        const backgroundColor: string = match(service)
          .with('NetSuite', () => GreyGrey20)
          .otherwise(() => GreyWhite)

        const iconSize: number = match(service)
          .with('NetSuite', () => 16)
          .otherwise(() => 24)

        return (
          <Tooltip key={service} label={service.replace(/_/g, ' ')}>
            <Center
              data-testid={`tableLinksLogos.${service}`}
              boxSize="24px"
              flexShrink={0}
              backgroundColor={backgroundColor}
              borderRadius="full"
              overflow="hidden"
            >
              {getLogo(service, iconSize)}
            </Center>
          </Tooltip>
        )
      })}
    </Flex>
  )
}
